import { cn } from "@/utils/cn";
import { DateUtils } from "@/utils/dayUtill";

export default function IssuedDate({
  issuedAtDisplay,
}: {
  issuedAtDisplay: Date | undefined;
}) {
  if (!issuedAtDisplay) {
    return null;
  }

  return (
    <div
      className={cn(
        "order-3 justify-self-center text-center text-sm leading-normal text-[#939399] sm:order-none",
        !issuedAtDisplay && "min-h-[1.25em] sm:min-h-0"
      )}
    >
      마감일시 :{" "}
      {DateUtils.dateFormatKR(issuedAtDisplay, "YYYY년 MM월 DD일 HH:mm")}
    </div>
  );
}
